<template>
  <div>
    <h1>{{ get("heading-0") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <p>
              {{ get("p-1") }}
            </p>
            <p>
              {{ get("p-2") }}
            </p>
            <p>
              {{ get("p-3") }}
            </p>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-img :src="houseImage" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("heading-1") }}</h2>
            <p>
              {{ get("p-1.1") }}
            </p>
            <h2>
              {{ get("p-1.2") }}
            </h2>
            <p>
              {{ get("p-1.3") }} {{ get("company")}} {{ get("p-1.4") }}
              <phonenumber phone="(719) 390-7663"></phonenumber>
              {{ get("p-1.5") }}
            </p>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <v-col cols="12">
              <h2>
                {{ get("heading-2") }}
              </h2>
              <p>
                {{ get("p-2.1") }}
              </p>
              <ol>
                <li>
                  <p>
                    <strong>{{ get("p-2.2") }}</strong>
                    - {{ get("p-2.3") }}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{{ get("p-2.4") }}</strong>
                    - {{ get("p-2.5") }}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{{ get("p-2.6") }}</strong> 
                    - {{ get("p-2.7") }}
                  </p>
                </li>
                <li>
                  <p>
                    <strong>{{ get("p-2.8") }}</strong>
                    - {{ get("p-2.9") }}
                  </p>
                </li>
              </ol>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>
              {{ get("heading-3") }}
            </h2>
            <p>
              {{ get("p-3.1") }} 
              <linkto :text="company" to="/"></linkto> 
              {{ get("p-3.2") }}
            </p>
            <h2>
              {{ get("p-3.3") }}
            </h2>
            <p>
              {{ get("p-3.4") }}
              <phonenumber phone="(719) 390-7663"></phonenumber> 
              {{ get("p-3.5") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Roofing-Ice-Dams",

  components: {
    estimate,
    linkto,
    phonenumber,
  },


  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "ice-dams";
  },

  data: () => ({
    houseImage: require("@/assets/ice-dam.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
</style>
